import $ from 'jquery';
import { ajaxCall} from "../includes/functions";
import Swal from 'sweetalert2';

// enable order pay to update on change payment method
jQuery(function(){
    // only to run on order pay page
    let elementCls = '.nc_deposit.nc-ajax-order-modifier';
    if($(elementCls).length > 0 )
    {
        // payment percentage wise order modifer
        $(elementCls+' input[type=radio]').on('change', function(e)
        {
            update_payment_order();
        });

        // payment method wise order modifier
        let paymentCls = '#payment .wc_payment_methods.payment_methods.methods';
        $(paymentCls+' input[type=radio]').on('change', function(e)
        {
            update_payment_order();
        });
    }

    function update_payment_order()
    {
        if( $('.nc_deposit.nc-ajax-order-modifier input[type=radio]:checked').length == 0 ) return;

        let checked = $('.nc_deposit.nc-ajax-order-modifier input[type=radio]:checked');
        let payPercent = checked.val();
        let paymentMethod = $('#payment .wc_payment_methods.payment_methods.methods input[type=radio]:checked').val();
        let orderId = $('input#kbcorder[name=order-id]').val();
        
        //block ui
        let blockUi = '<div class="blockUI blockOverlay ncloader" style="z-index: 1000; border: medium; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background: rgb(255, 255, 255); opacity: 0.6; cursor: default; position: absolute;"></div>';
        let form = $('#order_review');
        form.css('position', 'relative');
        form.append(blockUi);

        //send ajax call
        let data = {
            payPercent: payPercent,
            orderId: orderId,
            paymentMethod: paymentMethod,
            nonce: $('#kbc_payment_percentage').val()
        };
        let action = 'kbc_change_order_pay_percent';
        ajaxCall( data, action ).then((response)=>{
            if( response.status == false )
            {
                Swal.fire('Error', response.data, 'error');
                return false;
            }
            let cur = $('#order_review table').data('currency');
            $('#order_review td.kbc-remaining').html( cur + response.data.remaining );
            $('#order_review td.kbc-total').html( response.data.total );
            // hide default hidden items
            $('#order_review table tr.default-hide').each( function(){ 
                $(this).addClass('d-none'); 
            });

            if( parseFloat(response.data.fee) > 0 )
            {
                let feeEle = $('#order_review td.transaction-fee');
                feeEle.html( cur + response.data.fee );
                feeEle.parents('tr').removeClass('d-none');

                let payWithFee = $('#order_review td.paymentWithFee');
                payWithFee.html( '<strong>'+cur + response.data.paymentWithFee+'</strong>' );
                payWithFee.parents('tr').removeClass('d-none');
            }

            $('.blockUI.ncloader').remove();
        });
    }
    
    // my account pay for processing order
    $('a.nc-pay-order').on('click', function(e){
        e.preventDefault();

        // add spinner to button
        let spinner = '<div class="spinner-border spinner-border-sm ms-2" role="status"><span class="visually-hidden">Loading...</span></div>';
        let text = $(this).text();
        $(this).html( text + spinner).attr('disabled', true);

        let data = {
            action: 'kbc_pay_order',
            orderId: $(this).data('orderid'),
        };
        ajaxCall( data ).then((resp)=>{
            if( resp.status )
            {
                window.location.href = $(this).attr('href');
                return;
            }

            $(this).html( text ).attr('disabled', false);
            Swal.fire('Error', 'error',resp.error);
        });
    });

    // check deposit percentage selected on order pay
    if( $('form#order_review #deposit_field').length > 0 )
    {
        if( $('form#order_review #deposit_field input[type=radio]:checked').length == 0 )
        {
            $('form#order_review #deposit_field input[type=radio]')[0].checked = true;
            update_payment_order();
        }
    }

});